import { render } from "./QuotationListPage.vue?vue&type=template&id=bbb114da&ts=true"
import script from "./QuotationListPage.vue?vue&type=script&lang=ts"
export * from "./QuotationListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__